export default __webpack_public_path__ + "997ff59d685c254bceeb2eb9e1fcf2f1.svg";